<template>
  <b-modal id="saveorder"
           :title="showsetting.title"
           :ok-only="step==='success'"
           :lazy="true"
           :ok-title = "okTitle"
           :ok-disabled = "loading"
           @hidden = "hidden"
           @ok="save">
    <b-row class="row-box ">
      <b-col>
       <div v-if="step === 'input'">
        {{showsetting.message}}
       </div>
        <div v-if="step === 'success'">
          <b-alert show variant="success">
          An email has been sent to {{order.OrderContactInformation.Email}} with a link to retrieve your saved count.
          </b-alert>
          <br>
        </div>
      </b-col>
    </b-row>
    <b-form-group horizontal
                  :label-cols="4"
                  label-size="sm"
                  label="First Name :"
                  class="first-row-box">
      <b-input :disabled="step==='success'"
               :value = "orderContact.FirstName"
               data-test="summary-saveCount-firstName"
               @input.native="updateContact('FirstName', $event)">
      </b-input>
      <p class="m-error-text" v-if="showError && !orderContact.FirstName">Required</p>
    </b-form-group>

    <b-form-group horizontal
                  :label-cols="4"
                  label-size="sm"
                  label="Last Name :">
      <b-input :disabled="step==='success'"
               data-test="summary-saveCount-lastName"
               :value = "orderContact.LastName"
               @input.native="updateContact('LastName', $event)">
      </b-input>
      <p class="m-error-text" v-if="showError && !orderContact.LastName">Required</p>
    </b-form-group>

    <b-form-group horizontal
                  :label-cols="4"
                  label-size="sm"
                  label="Company Name :">
      <b-input :disabled="step==='success'"
               :value = "orderContact.Company"
               data-test="summary-saveCount-company"
               @input.native="updateContact('Company', $event)">
      </b-input>
      <p class="m-error-text" v-if="showError && !orderContact.Company">Required</p>
    </b-form-group>

    <b-form-group horizontal
                  :label-cols="4"
                  label-size="sm"
                  label="Email :">
      <b-input :disabled="step==='success'"
               :value = "orderContact.Email"
               data-test="summary-saveCount-email"
               @input.native="updateContact('Email', $event)">
      </b-input>
      <p class="m-error-text" v-if="showError && !orderContact.Email">Required</p>
    </b-form-group>

    <b-form-group horizontal
                  :label-cols="4"
                  label-size="sm"
                  label="Telephone :">
      <b-input :disabled="step==='success'"
               :value = "orderContact.Phone"
               data-test="summary-saveCount-phone"
               @input.native="updateContact('Phone', $event)">
      </b-input>
      <p class="m-error-text" v-if="showError && !orderContact.Phone">Required</p>
    </b-form-group>

    <b-form-group horizontal
                  :label-cols="4"
                  label-size="sm"
                  label="Name This Count :">
      <b-input :disabled="step==='success'"
               :value = "orderContact.OrderName"
               data-test="summary-saveCount-countName"
               @input.native="updateContact('OrderName', $event)">
      </b-input>
      <p class="m-error-text" v-if="showError && !orderContact.OrderName">Required</p>
    </b-form-group>

    <b-row class="row-box">
      <b-col>
        <b-form-checkbox v-model="CallMe" v-show="showsetting.callme">{{showsetting.CallMeText}}</b-form-checkbox>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-checkbox v-model="OrderForClients" v-show="showsetting.clients">{{showsetting.orderforclienttext}}</b-form-checkbox>
      </b-col>
    </b-row>
    <b-row class="row-box" v-show="alertDesc!==''">
      <b-col>
        <b-alert :show="alertDesc!==''" variant="warning">{{alertDesc}}</b-alert>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
  import MErrorText from '@/components/common/MerrorText'

  export default {
    components: {
      MErrorText
    },
    created () {
      this.selectGeos = this.$store.state.order.OrderGeos
      setTimeout(() => {
        this.selectGeos = this.$store.state.order.OrderGeos
      }, 1000)
    },
    data () {
      return {
        selectGeos: {},
        step: 'input',  // input  , success
        okTitle: 'Save',
        showError: false,
        loading: false,
        alertDesc: ''
      }
    },
    computed: {
      order () {
        return this.$store.state.order
      },
      showsetting () {
        if (this.$store.getters['order/IsEmailCampaign']) {
          return {
            title: 'Save Email Campaign Count',
            message: 'Please complete the form below to save your list selections. Upon completion you will:<br>1. Instantly receive links to download (pdf) and print this Quote<br>2. Receive an email with a link to retrieve your saved count',
            orderforclienttext: 'I order campaigns for my clients. Contact me about USADATA’s Reseller Program.',
            CallMeText: 'Please contact me to discuss this email campaign in more detail.',
            callme: true,
            clients: true,
            IsContactMeByEmail: true,  // TODO@Wilson not find
            IsSendEmailToList: false  // @TODO@Wilson not find
          }
        } else {
          return {
            title: 'Save List Count',
            message: 'Please complete the form below to save your selections. Upon completion you will receive an email with a link to retrieve your saved count at any time.',
            orderforclienttext: 'I order leads for my clients. Contact me about your Reseller Program.',
            CallMeText: 'Please call me to discuss this list in more detail.',
            callme: false,
            clients: true
          }
        }
      },
      message () {

      },
      orderContact () {
        return this.$store.state.order.OrderContactInformation || {}
      },
      OrderForClients: {
        get () {
          return this.orderContact.OrderForClients
        },
        set (val) {
          this.$store.commit('order/updateContactInformation', {
            key: 'OrderForClients',
            val: val
          })
        }
      },
      CallMe: {
        get () {
          return this.orderContact.CallMe
        },
        set (val) {
          this.$store.commit('order/updateContactInformation', {
            key: 'CallMe',
            val: val
          })
        }
      }
    },
    methods: {
      updateContact (key, e) {
        this.$store.commit('order/updateContactInformation', {
          key: key,
          val: e.target.value
        })
      },
      save (evt) {
        if (this.step === 'input') {
          evt.preventDefault()
        } else {
          return
        }
        this.alertDesc = ''
        if (!this.validate()) {
          return false
        }
        this.loading = true
        let order = JSON.parse(JSON.stringify(this.order))
        order.OrderPaymentInformation = null
        this.$http.post('PlaceOrder.aspx/SaveCount', {
          currentSessionId: this.$store.state.site.CurrentSessionId,
          order: order
        }, {
          errorType: 'custom'
        }).then(resp => {
          if (resp.body.d.DataSource.IsSuccess) {
            this.step = 'success'
            this.title = 'Thank you'
            this.okTitle = 'Close'
            this.loading = false
          } else {
            this.loading = false
            this.alertDesc = resp.body.d.DataSource.Message
          }
        }, resp => {
          this.loading = false
          this.alertDesc = resp.body.d.ResultMessage
        })
      },
      validate () {
        this.showError = false
        if (!this.orderContact.LastName) {
          this.showError = true
        }
        if (!this.orderContact.FirstName) {
          this.showError = true
        }
        if (!this.orderContact.Company) {
          this.showError = true
        }
        if (!this.orderContact.Email) {
          this.showError = true
        }
        if (!this.orderContact.Phone) {
          this.showError = true
        }
        if (!this.orderContact.OrderName) {
          this.showError = true
        }

        return !this.showError
      },
      hidden () {
        this.step = 'input'
        this.title = 'Save List Count'
        this.okTitle = 'Save'
      }
    }
  }
</script>

<style scoped lang="scss">
  .first-row-box {
    margin-top: 16px;
  }

</style>



// WEBPACK FOOTER //
// src/components/summary/MSaveOrder.vue